<template>
  <div
    v-show="showCalendarButtons"
    class="button-container"
    :class="showCalendarButtons && 'open'"
    role="group"
    :aria-label="$t('events.addToCalendar')"
    :style="primaryTextColor"
    @keydown.esc.exact.stop="handleBackButtonClick"
  >
    <AddToCalendar
      v-for="type in calendarOptions"
      :key="type.value"
      :calendar-type="type.value"
      :event-data="eventData"
      :color-overrides="colorOverrides"
      class="calendar-option"
    />
    <FormButton
      type="button"
      variant="default"
      mode="default"
      class="back-calendar-button"
      :full-width="true"
      :color-overrides="colorOverrides"
      :aria-label="useNewCloseIcon ? $t('events.back') : undefined"
      @click.stop.prevent="handleBackButtonClick"
      @keydown.tab.exact.stop="handleBlur"
    >
      <img
        v-if="useCloseIcon"
        src="../../../../../assets/close-icon.svg"
        :alt="$t('search.closeOptions')"
      />
      <Icon
        v-else-if="useNewCloseIcon"
        name="lucide:x"
        size="14"
        aria-hidden="true"
      />
      <span v-else>{{ $t('events.back') }}</span>
    </FormButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import FormButton from '../../../../global/Forms/FormButton.vue';
import AddToCalendar from '../shared/AddToCalendar.vue';
import { useThemedButtons } from '@/composables/useThemedButtons';

defineOptions({
  name: 'EventListButtons',
});

defineProps({
  handleBackButtonClick: {
    type: Function,
    default: () => {},
  },
  handleBlur: {
    type: Function,
    default: () => {},
  },
  colorOverrides: {
    type: Object,
    default: null,
  },
  eventData: {
    type: Object,
    default: null,
  },
  showCalendarButtons: Boolean,
  useCloseIcon: Boolean,
  useNewCloseIcon: Boolean,
});

const calendarOptions = [
  { idx: 0, name: 'Google', value: 'google' },
  { idx: 1, name: 'Outlook', value: 'outlook' },
  { idx: 2, name: 'iCal', value: 'iCal' },
];

const { themedButtons } = useThemedButtons();

const primaryTextColor = computed(() => ({
  '--primary-button-text': themedButtons['--secondary-button-text'],
}));
</script>

<style scoped lang="scss">
@use '../../../../global/scss/mixins/flex_mixin';
@use '../../../../global/scss/mixins/breakpoints';

.button-container {
  @include flex_mixin.flex-row;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;

  @media (min-width: breakpoints.$md) {
    @include flex_mixin.flex-column;
    justify-content: stretch;
  }

  &.open {
    @include flex_mixin.flex-column;
    justify-content: stretch;
  }

  & p.button-text {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;

    text-align: center;
    letter-spacing: 0.4px;

    color: #333333;
  }
  .back-calendar-button:hover {
    color: var(--primary-button-text);
  }
  .calendar-option,
  .back-calendar-button {
    &:focus-visible {
      outline: 2px solid #000fff;
    }
  }
  .back-calendar-button {
    .iconify {
      color: var(--primary-button-text);
    }
  }
  .calendar-option {
    &:hover {
      color: var(--primary-button-text);
    }
  }
}

.calendar-buttons {
  @include flex_mixin.flex-column;
}
</style>
